import ProfessionAndSpeciality from '../../CustomFilterComponents/ProfessionAndSpeciality';
import type { FilterConfigSubGroupItem } from '../FilterConfigTypes';

export const DTCProfessionComponent = (
  <ProfessionAndSpeciality professionFilterName="npi_profession_filter" specialtyFilterName="npi_specialty_filter" />
);

export const DTCSubGroupItems: Array<FilterConfigSubGroupItem> = [
  {
    groupLabelId: 'profession_and_speciality_subgroup',
    parentGroupLabel: 'NPI Attributes',
    groupLabel: 'Profession & Specialty',
    ordinalPosition: 1,
    tooltip:
      'Specify the profession & speciality of doctors to refine your audience. This filter allows you to target healthcare professionals based on their specific medical profession or role.',
    filtersInGroup: [
      { name: 'npi_profession_filter', index: 1 },
      { name: 'npi_specialty_filter', index: 2 },
    ],
    icon: 'Specialties',
    customComponent: DTCProfessionComponent,
  },
];
